import { CallCenterPartnerEnum } from '@/enums/crm/call-center/call-center-partner.enum';

export default class SettingsModel {
  flagHabilitaNovoPainelCliente!: boolean;

  flagConverteProspectIGS!: boolean;

  flagIntegraClienteAposConversaoProspect!: boolean;

  flagUsaSegundaViaBoletos!: boolean;

  flagExibeColunasAdicionaisInfoFinanceira!: boolean;

  flagIntegracaoSintegraAtivo!: boolean;

  urlCrmApp!: string;

  flagObrigaClassificacaoFechamentoConversa!: boolean;

  flagObrigaDescricaoFechamentoConversa!: boolean;

  flagTornarCnpjProspectObrigatorio!: boolean;

  flagTornarRazaoSocialProspectOpcional!: boolean;

  flagTornarFantasiaProspectObrigatorio!: boolean;

  flagUtilizaWhatsapp!: boolean;

  flagUtilizaAgenda!: boolean;

  flagExcluiAgenda!: boolean;

  loggedUserType!: number;

  flagPermiteExcluirAnexos!: boolean;

  flagMostraChatsUsuariosRootVisaoGeral!: boolean;

  flagObrigaClassificacaoEmail!: boolean;

  flagHabilitaMenuVisitas!: boolean;

  flagPermiteEditarParticularidades!: boolean;

  flagHabilitaMenuClientesCidadeProspect!: boolean;

  flagCongelaPreenchimentoSintegra!: boolean;

  flagNaoPreencheTelefoneEmailProspectSintegra!: boolean;

  flagEmailProspectObrigatorio!: boolean;

  flagTelefoneProspectObrigatorio!: boolean;

  flagPermiteCadastroAtendenteChave!: boolean;

  flagMenuVendasColecaoErp!: boolean;

  flagRemoveObrigatorioRepresentanteAgenda360!: boolean;

  flagApresentaRepresentantesInativosAgenda360!: boolean;

  flagIntegracaoClienteUnicoAtivo!: boolean;

  flagPermiteClientesSituacao99Crm360!: boolean;

  realizaEnvioCampanhasInformativos!: boolean;

  flagEnviaContatoErp!: boolean;

  tituloColunaCoringa1Pedidos!: string;

  tituloCoringa1Cliente?: string | null;

  tituloCoringa2Cliente?: string | null;

  tituloCoringa3Cliente?: string | null;

  tituloCoringa4Cliente?: string | null;

  flagGeoCodificacao!: boolean;

  urlAcessoExterno!: string;

  urlAcessoInterno!: string;

  urlAcessoGeo360!: string;

  flagWhatsApp360Ativo!: boolean;

  isCRMEvoTalks!: boolean;

  isWhatsAppEvoTalksAtivo!: boolean;

  flagUtilizaEvoTalks!: boolean;

  urlBaseEvoTalks!: string;

  flagUtilizaTelefonia!: boolean;

  partnerCodeCallCenter!: number;

  quantidadeGestoesPainelRelacionamento!: number;

  get isCloudTalkPartner(): boolean {
    return this.partnerCodeCallCenter === CallCenterPartnerEnum.CloudTalk.valueOf();
  }

  flagAbreParticularidadesPainelCliente!: number;

  flagExibirProspectFVPadrao!: boolean;

  flagIdentificaContatoMaisCinquenta!: number;

  whatsappDirecionamentoUrl!: string;

  flagHabilitaAbrirProcessoNoDialog!: boolean;

  flagPermiteAlterarAtendenteChaveEmMassa!: boolean;

  flagIntegracaoRDStation!: boolean;

  flagValidaCompraMenorNaJusticacao!: boolean;

  usaChatVendas!: boolean;

  numeroCanalChatVendas!: string;

  isEvoTalksEGeoChatHabilitado!: boolean;

  moduloGeochatAtivo!: boolean;

  flagDepartamentoObrigatorioAgenda!: boolean;

  flagExpandirParticularidadesPorPadrao!: boolean | null;

  flagObrigatorioPreenchimentoDescricaoCriarAgenda!: boolean | null;

  flagObrigatorioPreenchimentoObservacaoInternaCriarAgenda!: boolean | null;
}
